import table from "../images/table.png";
import pin from "../images/pin.png";
import { Button } from "../../ui";
import { useState, type FC } from "react";
import { Location } from "../../location";

export const Target: FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <div className="flex flex-col items-center justify-center w-full h-full mt-7 gap-5">
      <div>
        <img
          src={pin}
          alt="Pin"
          className="w-16 h-16 object-contain animate-bounce"
        />
        <img src={table} alt="Table" className="w-16  object-contain " />
      </div>

      <div>
        <h3 className="text-center text-3xl font-bold text-[var(--secondary)]">
          «Серая Шейка»
        </h3>

        <p className="text-center text-sm font-medium text-[var(--primary)]">
          а.г. Полыковичи, ул. Центральная 72А
        </p>
      </div>

      <Button size="sm" onClick={() => setIsOpen(true)}>
        <span style={{ fontFamily: "ofont_flow" }}>Посмотреть карту</span>
      </Button>

      <Location isOpen={isOpen} onClose={onClose} />
    </div>
  );
};
